export const BIZOPS_INTERACTION = 'bizops-interaction';
export const CRM_ONBOARDING = 'crm-onboarding';
export const INDEX_INTERACTION = 'index-interaction';